import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-plus",
  "use": "icon-plus-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"icon-plus\"><path d=\"M10.005 20c.503 0 .93-.4.93-.883v-8.202h8.143a.933.933 0 0 0 .922-.91.927.927 0 0 0-.922-.91h-8.142V.881c0-.483-.428-.882-.931-.882-.513 0-.931.4-.931.882v8.212H.93c-.494 0-.931.409-.931.91 0 .493.437.911.931.911h8.143v8.203c0 .483.418.882.93.882Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol